'use client';

import useSimpleApiHandler from '@frontend/jetlend-core/src/hooks/useSimpleApiHandler';
import React, { useMemo } from 'react';
import { getAssetSrc } from '@frontend/jetlend-web-ui/src/utils/getAssetSrc';
import { accountInfoHandler } from '@app/ducks/common/account';
import Image from '@app/components/Image/Image';
import background from '@app/icons/academy/academy-header2.jpg';
import HeaderAchievementSlider from './HeaderAchievementSlider/HeaderAchievementSlider';
import HeaderLastCourseBlock from './HeaderLastCourseBlock/HeaderLastCourseBlock';
import HeaderRecommendedCourse from './HeaderRecommendedCourse/HeaderRecommendedCourse';
import {
    getRecommendedCoursesHandler,
    getUserCoursesHandler,
} from '@app/ducks/academy/course';
import {
    IAchievementItemApiModel,
    ICourseInformationApiModel,
} from '@app/models/features/course';
import styles from './HeaderSection.module.scss';

export interface IProps {
    /**
     * Список ачивок
     */
    achievements: IAchievementItemApiModel[];
    /**
     * Список всех курсов
     */
    courses: ICourseInformationApiModel[];
}

/**
 * Компонент для отрисовки верхней части страницы академии
 */
const HeaderSection: React.FC<IProps> = props => {
    const {
        achievements,
        courses,
    } = props;
    const [account] = useSimpleApiHandler(accountInfoHandler);
    const [recommendedCourses] = useSimpleApiHandler(getRecommendedCoursesHandler);
    const [userCourses] = useSimpleApiHandler(getUserCoursesHandler);

    const notPassedCourses = useMemo(() => userCourses?.filter(item => !item?.passed), [userCourses]);
    const lastCourse = useMemo(() => notPassedCourses?.[notPassedCourses?.length-1], [notPassedCourses]);
    const courseInfo = courses.find(item => item?.id === lastCourse?.id);
    const sortAchievements = useMemo(() => achievements?.sort(item => item?.achieved ? -1 : 1), [achievements]);

    return (
        <>
            <div className={styles['wrapper']} style={{ backgroundImage: `url(${getAssetSrc(background)})` }}>
                <div className={styles['item-title']}>
                    <span>
                        С возвращением
                        {account?.name && ','}
                    &nbsp;
                    </span>
                    <span>{account?.name && account.name}</span>
                </div>
                <div className={styles['item']}>
                    {sortAchievements && sortAchievements?.length > 0 && (
                        <HeaderAchievementSlider>
                            {sortAchievements?.map(achievement => (
                                <Image
                                    key={achievement.title}
                                    src={achievement.icon}
                                    className={!achievement.achieved && styles['default-icon']}
                                    alt=""
                                    fill
                                />
                            ))}
                        </HeaderAchievementSlider>
                    )}
                </div>
            </div>
            {lastCourse && (
                <HeaderLastCourseBlock
                    courseInfo={courseInfo}
                    lastCourse={lastCourse}
                />
            )}
            {recommendedCourses && recommendedCourses?.length > 0 && (
                <HeaderRecommendedCourse
                    recommendedCourses={recommendedCourses}
                    achievements={achievements}
                />
            )}
        </>
    );
};

export default HeaderSection;